// Simplified api.js - MongoDB Only Version
import axios from 'axios';

// Backend configuration - hardcoded for MongoDB
const API_URL = 'https://crm-backend-wt76.onrender.com';

// Create API client
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 10000
});

// Client API
export const clientsAPI = {
  getAll: () => apiClient.get('/api/clients'),
  getById: (id) => apiClient.get(`/api/clients/${id}`),
  create: (client) => apiClient.post('/api/clients', client),
  update: (id, client) => apiClient.put(`/api/clients/${id}`, client),
  delete: (id) => apiClient.delete(`/api/clients/${id}`)
};

// Template API
export const templatesAPI = {
  getAll: () => apiClient.get('/api/templates'),
  getById: (id) => apiClient.get(`/api/templates/${id}`),
  create: (template) => apiClient.post('/api/templates', template),
  update: (id, template) => apiClient.put(`/api/templates/${id}`, template),
  delete: (id) => apiClient.delete(`/api/templates/${id}`)
};

// Campaign API
export const campaignsAPI = {
  getAll: () => apiClient.get('/api/campaigns'),
  getById: (id) => apiClient.get(`/api/campaigns/${id}`),
  create: (campaign) => apiClient.post('/api/campaigns', campaign),
  update: (id, campaign) => apiClient.put(`/api/campaigns/${id}`, campaign),
  delete: (id) => apiClient.delete(`/api/campaigns/${id}`),
  getAnalytics: (id) => apiClient.get(`/api/campaigns/${id}/analytics`)
};

// Standard API functions
export const getClientsData = () => clientsAPI.getAll().then(res => res.data);
export const getClientById = (id) => clientsAPI.getById(id).then(res => res.data);
export const saveClient = (client) => clientsAPI.create(client).then(res => res.data);
export const updateClient = (id, client) => clientsAPI.update(id, client).then(res => res.data);
export const deleteClient = (id) => clientsAPI.delete(id).then(res => res.data);

export const getTemplatesData = () => templatesAPI.getAll().then(res => res.data);
export const getTemplateById = (id) => templatesAPI.getById(id).then(res => res.data);
export const saveTemplate = (template) => templatesAPI.create(template).then(res => res.data);
export const updateTemplate = (id, template) => templatesAPI.update(id, template).then(res => res.data);
export const deleteTemplate = (id) => templatesAPI.delete(id).then(res => res.data);

export const getCampaignsData = () => campaignsAPI.getAll().then(res => res.data);
export const getCampaignById = (id) => campaignsAPI.getById(id).then(res => res.data);
export const saveCampaign = (campaign) => campaignsAPI.create(campaign).then(res => res.data);
export const updateCampaign = (id, campaign) => campaignsAPI.update(id, campaign).then(res => res.data);
export const deleteCampaign = (id) => campaignsAPI.delete(id).then(res => res.data);
export const getAnalyticsData = () => apiClient.get('/api/analytics').then(res => res.data);

// For dashboard, provide an empty implementation
export const getDashboardData = () => Promise.resolve({});

export default {
  clients: clientsAPI,
  templates: templatesAPI,
  campaigns: campaignsAPI
};